import React, { useState, useEffect, useContext } from 'react';
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination, Grid } from '@mui/material';
import moment from 'moment';
import Sidebar from '../../components/Sidebar/Sidebar';
import DateRangePicker from '../../components/DateRangePicker/DateRangePicker';
import { UserContext } from '../../contexts/UserContext';
import { searchAgentTicketsByDate } from '../../utils/apiUtils';
import './PersonalCSAT.scss';

const PersonalCSATPage = () => {
  const { user } = useContext(UserContext);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [tickets, setTickets] = useState([]);
  const [filteredTickets, setFilteredTickets] = useState([]);
  const [page, setPage] = useState(0);
  const [positivePercent, setPositivePercent] = useState(0);
  const [neutralPercent, setNeutralPercent] = useState(0);
  const [negativePercent, setNegativePercent] = useState(0);
  const rowsPerPage = 30;

  const formatDate = (date) => {
    return date ? moment(date).format('DD-MM-YYYY HH:mm') : '';
  };

  useEffect(() => {
    const fetchTicketsByDate = async () => {
      if (startDate && endDate) {
        try {
          let tickets = await searchAgentTicketsByDate(user.discordId, startDate, endDate);
          setTickets(tickets);

          let filteredTickets = tickets.filter(ticket => ticket.ticket_score !== null);
          setFilteredTickets(filteredTickets);

          // Calculate CSAT scores
          const PositiveReviews = filteredTickets.filter(ticket => ticket.ticket_score >= 4).length;
          const NeutralReviews = filteredTickets.filter(ticket => ticket.ticket_score === 3).length;
          const NegativeReviews = filteredTickets.filter(ticket => ticket.ticket_score <= 2).length;          
          let totalReviews = PositiveReviews + NeutralReviews + NegativeReviews;

          setPositivePercent(((PositiveReviews / totalReviews) * 100).toFixed(2));
          setNeutralPercent(((NeutralReviews / totalReviews) * 100).toFixed(2));
          setNegativePercent(((NegativeReviews / totalReviews) * 100).toFixed(2));

        } catch (error) {
          console.error('Error fetching tickets:', error);
        }
      }
    };

    fetchTicketsByDate();
  }, [startDate, endDate]);

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  return (
    <Box className="StyledContainer">
      <Sidebar />

      <Box className="StyledContent">
        <Typography variant="h2">Personal CSAT</Typography>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box className="StyledButtonContainer">
              <Box className="StyledCard">
                <Typography variant="h5">Date Range</Typography>
                <DateRangePicker
                  startDate={startDate}
                  endDate={endDate}
                  onStartDateChange={handleStartDateChange}
                  onEndDateChange={handleEndDateChange}
                />
              </Box>
              <Box className="StyledCard">
                <Typography variant="h5">CSAT Sent</Typography>
                <Typography variant="body2" className="count">{tickets.filter(ticket => ticket.feedback_sent !== null).length}</Typography>
              </Box>
              <Box className="StyledCard">
                <Typography variant="h5">CSAT Received</Typography>
                <Typography variant="body2" className="count">{tickets.filter(ticket => ticket.feedback_received !== null).length}</Typography>
              </Box>
              <Box className="StyledCard">
                <Typography variant="h5">CSAT Score</Typography>
                <Typography variant="body2" className="count">Positive: {positivePercent}%</Typography>
                <Typography variant="body2" className="count">Neutral: {neutralPercent}%</Typography>
                <Typography variant="body2" className="count">Negative: {negativePercent}%</Typography>
                <Typography variant="body2">Out of: {tickets.filter(ticket => ticket.ticket_score !== null).length}</Typography>
              </Box>
              <Box className="StyledCard">
                <Typography variant="h5">Total Tickets</Typography>
                <Typography variant="body2" className="count">{tickets.length}</Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Ticket Owner</TableCell>
                <TableCell>Ticket ID</TableCell>
                <TableCell>Ticket Name</TableCell>
                <TableCell>Created At</TableCell>
                <TableCell>Closed At</TableCell>
                <TableCell>Score</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(rowsPerPage > 0
                ? filteredTickets.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : filteredTickets
              ).map((ticket) => (
                <TableRow key={ticket.ticket_id}>
                  <TableCell>{ticket.ticket_owner_name}</TableCell>
                  <TableCell>{ticket.ticket_id}</TableCell>
                  <TableCell>{ticket.ticket_name}</TableCell>
                  <TableCell>{formatDate(ticket.ticket_created)}</TableCell>
                  <TableCell>{formatDate(ticket.ticket_closed)}</TableCell>
                  <TableCell>{ticket.ticket_score}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[30]}
            component="div"
            count={filteredTickets.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
          />
        </TableContainer>
      </Box>
    </Box>
  );
};

export default PersonalCSATPage;
